module.exports = __webpack_public_path__ + "img/spongebob-square-pants-banner.a13e5310.webp";